// extracted by mini-css-extract-plugin
module.exports = {"container":"dentureLedgerPage_container__ntuuf","patientOverlay":"dentureLedgerPage_patientOverlay__4v67a"};